<template>
  <div id="app">
    <el-menu router="true" class="el-menu-demo" mode="horizontal">
      <li class="title el-menu-item">
        <img class="logo" src="@/assets/logo2.png" alt="">
      </li>
      <li class="title el-menu-item">
        <img class="logo" src="@/assets/logo.png" alt="">
      </li>
      <el-menu-item index="index" route="/">{{ $t('default.login') }}
      </el-menu-item>
      <el-menu-item index="yjtd" route="/yjtd">{{ $t('default.yjtd') }}
      </el-menu-item>
      <el-menu-item index="yjxx"  route="/yjxx">{{$t('default.yjxx')}}
      </el-menu-item>
      <el-menu-item index="about" route="/about">{{$t('default.contact_us')}}
      </el-menu-item>
      <el-dropdown class="lang-select" @command="changeLang">
        <span class="el-dropdown-link">
          {{langMap[lang]}}<i class="el-icon-arrow-down el-icon--rigt"></i>
        </span>
        <el-dropdown-menu slot="dropdown" >
          <el-dropdown-item command="zh-CN">简体中文</el-dropdown-item>
          <el-dropdown-item command="en">English</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </el-menu>
    <router-view/>
  </div>
</template>


<script>
import _ from 'lodash'
export default {
  components: {
  },
  data() {
    return {
      langMap: {
        'zh-CN': '简体中文',
        tc: '繁體中文',
        en: 'English'
      },
      lang: window.lang
    }
  },
  methods: {
    changeLang (lang) {
      localStorage.setItem('lang', lang)
      window.location.reload()
    }
  }
}
</script>
<style lang="less">
@media screen and (max-width: 500px) {
  .el-menu-demo {
    margin-bottom: 0;
    .logo {
      width: 40vw!important;
    }
    .el-menu-item {
      font-size: 16px!important;
      padding: 0px 15px;
    }
  }
}
.lang-select {
  position: relative;
  top: 18px;
}
*, body {
  margin: 0 0;
  /* overflow: hidden; */
}
#app {
  text-align: center;
  color: #2c3e50;
  a:-webkit-any-link {
  }
  .logo {
    width: 150px;
  }
  .el-menu-demo {
    margin-bottom: 0;
    .el-menu-item {

    }
  }
}

</style>
